import { useState, useEffect, createContext } from 'react'
import LazyLoad from 'vanilla-lazyload'
import PropTypes from 'prop-types'

const Context = createContext()
const Options = {
  elements_selector: '[loading=lazy]',
  class_loaded: 'is-loaded',
  class_error: 'has-error'
}

export const LazyImageProvider = (props) => {
  const { children } = props
  const [lazyLoad, setLazyLoad] = useState(null)

  useEffect(() => {
    if (!lazyLoad) setLazyLoad(new LazyLoad(Options))
    return () => lazyLoad && lazyLoad.destroy()
  }, [lazyLoad])

  return <Context.Provider value={lazyLoad}>{children}</Context.Provider>
}

LazyImageProvider.propTypes = {
  children: PropTypes.object
}

// eslint-disable-line react/display-name
export const withLazyImageContext = (Component) => (props) =>
  <Context.Consumer>{(context) => <Component {...props} lazyLoad={context} />}</Context.Consumer>
